import { CategoryUsageGuide } from "modules/productUsageGuides";

const CategoryUsageGuidePage = () => {
  return <CategoryUsageGuide />;
};

export default CategoryUsageGuidePage;
